import { Grid2, Checkbox, FormControlLabel } from "@mui/material";
import { getFormatedDate } from "../../../_helpers/dateTime.helper";
import { StandardTextValidator } from "../../../_components/textValidator/standardTextValidator";
import EnumSelect from "../../../_components/autocomplete/enum.select";
import { TicketServeTypeEnum } from "../../../_common/enum/ticketServeType.enum";

export function TicketSurveillance({ data, setData, handleChange }: {
    data: any;
    setData: (_data: any) => void;
    handleChange: (event: any) => void;
}) {
    return (
        <>
            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="startDate"
                    name="startDate"
                    label="Start Date"
                    type="date"
                    fullWidth
                    required
                    validators={['required']}
                    errorMessages={['required field']}
                    value={data.startDate != null ? getFormatedDate(data.startDate) : ""}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12 }}>
                <StandardTextValidator
                    key="endDate"
                    name="endDate"
                    label="End Date"
                    type="date"
                    fullWidth
                    value={data.endDate != null ? getFormatedDate(data.endDate) : ""}
                    onChange={handleChange}
                />
            </Grid2>

            <Grid2 size={{ xs: 12, md: 6 }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={!!data.isDiscreet}
                            onChange={(e) =>
                                setData((_data: any) => ({
                                    ..._data,
                                    isDiscreet: e.target.checked
                                }))
                            }
                            name="isDiscreet"
                            required
                        />
                    }
                    label="Discreet"
                />
            </Grid2>
        </>
    );
}